import { createFeatureScope } from 'bundles/product-features';

export const { ProductFeaturesQuery, withProductFeatures, useProductFeatures } = createFeatureScope({
  globalPayments: {
    enableFinancialAidLink: true,
    enablePartnerSupportedAccess: false,
  },
});
